/**
 * Nombres visibles de las canchas.
 *
 * El identificador (`techada`, `exterior`) es dato de negocio y vive en el dominio; el
 * texto que ve una persona es presentacion y vive aca. Asi se puede cambiar como se
 * llaman en la pantalla sin tocar identificadores que ademas forman parte de las claves
 * de `slotsOcupados` (ADR-008).
 */

import type { CanchaId } from '@padel/domain';

interface DatosCancha {
  readonly nombre: string;
  readonly descripcion: string;
}

const CANCHAS_VISIBLES: Readonly<Record<CanchaId, DatosCancha>> = {
  techada: {
    nombre: 'Cancha techada',
    descripcion: 'Bajo techo. Se juega igual con lluvia.',
  },
  exterior: {
    nombre: 'Cancha exterior',
    descripcion: 'Al aire libre, con toda la energia del complejo.',
  },
};

/** Nombre y descripcion de una cancha, para mostrar. */
export function datosDeCancha(canchaId: CanchaId): DatosCancha {
  return CANCHAS_VISIBLES[canchaId];
}

/** Solo el nombre. */
export function nombreDeCancha(canchaId: CanchaId): string {
  return CANCHAS_VISIBLES[canchaId].nombre;
}
